import React from 'react';
import { FiArrowUpRight, FiCreditCard, FiRefreshCw } from 'react-icons/fi';
import adaboCashLogo from '../image/adabo_cash_logo.png';

export function AuthBrand({ subtitle }) {
  return (
    <>
      <div className="auth-brand">
        <img src={adaboCashLogo} alt="Adabo Cash" className="auth-logo" />
        <div className="auth-brand-text"><span className="auth-brand-adabo">Adabo</span><span className="auth-brand-cash">Cash</span></div>
      </div>
      {subtitle && <p className="auth-subtitle">{subtitle}</p>}
    </>
  );
}

export function AuthCard({ children, description, title }) {
  return (
    <div className="auth-container">
      <div className="auth-card">
        <h2>{title}</h2>
        {description && <p className="password-reset-description">{description}</p>}
        {children}
      </div>
    </div>
  );
}

export function AuthFinancialPreview() {
  return (
    <div className="auth-financial-preview" aria-label="Aperçu des cartes virtuelles et services crypto">
      <div className="auth-card-stack" aria-hidden="true">
        <div className="auth-virtual-card auth-virtual-card--back">
          <span>VIRTUAL</span>
          <FiCreditCard />
        </div>
        <div className="auth-virtual-card auth-virtual-card--front">
          <div className="auth-virtual-card__top">
            <span className="auth-virtual-card__brand">Adabo<span>Cash</span></span>
            <span className="auth-virtual-card__type">VIRTUAL</span>
          </div>
          <div className="auth-card-chip">
            <i />
            <i />
            <i />
          </div>
          <div className="auth-virtual-card__number">••••&nbsp;&nbsp;••••&nbsp;&nbsp;••••&nbsp;&nbsp;4821</div>
          <div className="auth-virtual-card__bottom">
            <span><small>EXPIRE</small>12/29</span>
            <span className="auth-card-network"><i /><i /></span>
          </div>
        </div>
      </div>

      <div className="auth-crypto-preview">
        <span className="auth-crypto-preview__coin">₮</span>
        <span className="auth-crypto-preview__copy">
          <small>Services crypto</small>
          <strong>Achat &amp; échange USDT</strong>
        </span>
        <span className="auth-crypto-preview__action">
          <FiRefreshCw />
          <FiArrowUpRight />
        </span>
      </div>
    </div>
  );
}
